const testimonials = [
  {
    id: "t1",
    quote: "Mind Odyssey completely transformed how I approach my career. Within 3 months of the Career Accelerator program, I landed a role with a 40% salary increase. The coaching community kept me accountable every step of the way.",
    author: "Jordan Lee",
    role: "Senior Product Manager",
    avatar: "https://public.readdy.ai/ai/img_res/9c4928218a26557fbc31b31dac41185c.jpg",
    rating: 5,
  },
  {
    id: "t2",
    quote: "As a coach, the monetization tools are incredible. I've earned over $15,000 in my first 6 months just from my Mindset Reset program. The platform handles everything — payments, community, messaging. I just focus on coaching.",
    author: "Aisha Mensah",
    role: "Certified Mindset Coach",
    avatar: "https://readdy.ai/api/search-image?query=young%20african%20woman%20smiling%20confident%20portrait%20clean%20background%20studio&width=60&height=60&seq=test2&orientation=squarish",
    rating: 5,
  },
  {
    id: "t3",
    quote: "The corporate coaching program helped me go from a stressed middle manager to a confident executive. The community gallery is where I found my coach — seeing their work before committing was a game-changer.",
    author: "David Chen",
    role: "VP of Operations",
    avatar: "https://readdy.ai/api/search-image?query=professional%20chinese%20man%20executive%20smiling%20portrait%20clean%20background&width=60&height=60&seq=test3&orientation=squarish",
    rating: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-[#F7F6F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-teal-600 text-sm font-semibold tracking-widest uppercase">Success Stories</span>
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mt-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Real People,
            <br />
            <span className="text-teal-600">Real Transformations</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-white rounded-2xl p-8 border border-gray-100">
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <blockquote
                className="text-gray-700 text-sm leading-relaxed mb-6"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                "{t.quote}"
              </blockquote>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.author}
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <p className="font-semibold text-gray-900 text-sm">{t.author}</p>
                  <p className="text-gray-400 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
